import styles from './style.module.css';
import Item from "./item"
import Button from 'skin/entry/cmp/button';
import useData from './hook';
import Field from 'skin/entry/cmp/field';
import Drop from 'skin/entry/cmp/drop';
import Address from './address';

export default function Data({ data, value, setValue, reset, err }) {
	const { arr, address, wait, onChange, list } = useData(data);
	return <div>
		<div className={styles.header}>
			<h4>Организация</h4>
			<Button icon='user' mini type='link' onClick={reset}>Изменить ИНН</Button>
		</div>
		<div className={styles.container}>
			{arr.map(([id, label, v, input]) => <Item key={id} label={label} value={v} input={input} />)}
			{data.type === 'INDIVIDUAL' && <Item label='Адрес'>
				<Drop>
					<Drop.Trigger err={err} placeholder='Выберите адрес'>
						{value}
					</Drop.Trigger>
					<Drop.Menu maxHeight={180}>
						<Field type='layer1' icon='pin' placeholder='Начните вводить адрес' value={address} onChange={onChange} />
						<Address wait={wait} list={list} value={address} setValue={setValue} />
					</Drop.Menu>
				</Drop>
			</Item>}
		</div>
	</div>
}